export default __webpack_public_path__ + "static/media/Recording-movie-pana.f1b654ff.png";